// extracted by mini-css-extract-plugin
export default {"diceContainer":"styles_diceContainer__WXObO","diceBG":"styles_diceBG__tnC7G","diceInActive":"styles_diceInActive__yvDsH"};